import { attr, fk, Model } from 'redux-orm';

class PatientDocument extends Model {
  static modelName = 'PatientDocument';

  static fields = {
    id: attr(),
    fileName: attr(),
    fileType: attr(),
    fileCategory: attr(),
    path: attr(),
    size: attr(),
    status: attr(),
    updatedAt: attr(),
    createdAt: attr(),
    updatedBy: fk('Client', 'documentChanger'),
    createdBy: fk('Client', 'documentCreator'),
    patientId: fk({
      to: 'Patient',
      as: 'patient',
      relatedName: 'patientDocuments',
    }),
  };
}

export default PatientDocument;
